<template>

  <div class="mt-4">
    <div class="row">
      <div class="col-md-12">
        <b-card class="mt-2 mb-4 shadow-sm">
          <b-form v-unsave-detector @submit.stop.prevent="clickOnValidateBtn">
            <div class="row">
              <div class="col-md-6">
                <label class="font-weight-bolder">{{ this.currentStep + 1 + " sur 4" }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="font-weight-bolder secondary-color h6">{{ $t('operation.dossier.step3.1.title') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label class="mb-3">{{ $t('operation.dossier.step3.1.subtitle') }}</label>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  :invalid-feedback="form.investissement.invalidFeedback"
                  :label="$t('operation.dossier.field.text')"
                  :state="form.investissement.state"
                  class="medium-label mb-4"
                  label-for="texte-explicatif-input">
                  <VueEditor id="texte-explicatif-input" v-model="form.investissement.value"
                             :editorToolbar="customToolbar" v-on:input="emitChangeValue"></VueEditor>
                </b-form-group>
              </div>
              <div class="col-md-6">
              </div>
            </div>
            <div class="d-flex justify-content-end">
              <b-button type="submit" variant="primary">{{ $t('next') }}</b-button>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>

  </div>

</template>

<script>
import api from '../../../services/api'
import {VueEditor} from "vue2-editor";

export default {
  name: "DossierOperationInvestissement",
  components: {
    VueEditor
  },
  props: {
    currentStep: Number,
    investmentCreationDone: Boolean,
    dossierId: Number
  },

  data() {
    return {
      investissement: {},
      form: {
        investissement:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
      },
      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        ['blockquote', 'code-block'],
        [{list: "ordered"}, {list: "bullet"}],
      ]
    }
  },
  emits: ['didContinue', 'didBack', 'didChangeValue'],

  async mounted() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      if (this.dossierId && this.investmentCreationDone) {
        await this.fetchInvestissement()
        this.setInitialValues()
      }
    },

    async fetchInvestissement() {
      await api
        .get(`/investment/getInvestmentByDossier/${this.dossierId}`)
        .then(response => {
          this.investissement = response.data
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {
            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          }
        })
    },

    setInitialValues() {
      if (this.dossierId != null) {
        if (this.investissement.explication && !this.investissement.explication.includes('null')) {
          this.form.investissement.value = this.investissement.explication
        }
      }
    },

    async emitChangeValue() {
      this.$emit('didChangeValue')
    },

    /** Bouton validate (Etape suivante)
     */
    clickOnValidateBtn() {
      this._save(response => {
        this.$emit('didContinue', response.data.id)
      }, () => {
        this.$nextTick(() => {
          this.successToast(this.form.investissement.value, 'f.added')
        })
      })
    },

    /** Bouton save (Sauvegarder)
     *  save + success toast (pas de redirection)
     */


    _save(onSuccessClosure) {
      let data = new FormData()
      data.append('dossierId', this.dossierId)
      data.append('texteInvestment', this.form.investissement.value)

      api({
        method: this.investissement.id ? 'PUT' : 'POST',
        url: this.investissement.id ? `investment/${this.investissement.id}` : 'investment',
        data: data
      })
        .then((response) => {
          if (onSuccessClosure) onSuccessClosure(response)
        })
        .catch((error) => {
          if (error.response.status === 401 || error.response.status === 404) {

            this.$router.push({
              name: 'OperationIndex',
              params: {
                message: error.response.data.message
              }
            })
          } else if (error.response.status === 403) {
            const invalidField = error.response.data.invalidField
            this.form[invalidField]['state'] = false
            this.form[invalidField]['invalidFeedback'] = this.$i18n.t(error.response.data.message)
          }
        })
    },

    /** Success toast quand le dossier Operation est créée/modifiée
     */
    successToast(operationName, actionName) {
      this.$bvToast.toast("Situation opération" + this.$i18n.t(actionName), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true,
        variant: "success",
        solid: true,
      })
    }
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/operationDossier/dossierOperationCreateSteps/DossierOperationInvestissement.vue